import ctLogo from "./icons/icon_dtr.svg";
import iconPrinter from "./icons/icon_printer.svg";

import iconRightArrow from "./icons/icon_arrow_right.svg";
import iconLeftArrow from "./icons/icon_arrow_left.svg";

export default () => {

    // footer

    document.getElementById("footerDtr").innerHTML = ctLogo;

    // slider arrows

    document.querySelectorAll(".carousel__button--prev").forEach((el) => {
        el.innerHTML = iconLeftArrow;
    });
    document.querySelectorAll(".carousel__button--next").forEach((el) => {
        el.innerHTML = iconRightArrow;
    });

    // printer icon

    if (document.getElementById("iconPrinter"))
        document.getElementById("iconPrinter").innerHTML = iconPrinter;
};
